module.exports = __webpack_public_path__ + "img/children.fa1bbe21.jpg";